import { Account } from '../../types/management-auth';

export enum ActionTypes {
    GetAccount = '[welcome] GET_ACCOUNT',
    FetchAccountResponse = '[welcome] FETCH_ACCOUNT_RESPONSE',
    CloseModal = '[welcome] CLOSE_MODAL',
}

export interface GetAccount {
    type: ActionTypes.GetAccount;
    payload: {
        accountId: string;
    };
}

export function getAccount(accountId: string): GetAccount {
    return {
        type: ActionTypes.GetAccount,
        payload: {
            accountId,
        },
    };
}

export interface CloseModal {
    type: ActionTypes.CloseModal;
    payload: {
        accountId: string;
    };
}

export function closeModal(accountId: string): CloseModal {
    localStorage.setItem(`welcome_modal_closed_${accountId.substr(1)}`, 'true');
    return {
        type: ActionTypes.CloseModal,
        payload: {
            accountId,
        },
    };
}

export interface FetchAccountResponse {
    type: ActionTypes.FetchAccountResponse;
    payload: {
        account: Account;
    };
    meta: {
        cause: GetAccount;
    };
}

export type Actions = GetAccount | FetchAccountResponse | CloseModal;
